<template>
  <div class="flex items-center justify-center pb-4">
    <zt-off-canvas position="right" max-width="420px" :active="true" @close="$emit('close')">
      <vue-loading background-color="rgba(0,0,0,0.0)" :active="isSendingQuestion" color="#4F41A3"
        :is-full-page="true" />
      <div class="p-4">
        <div class="flex justify-between items-center">
          <button @click="$emit('close')" class=" hover:text-blue-800 text-xl font-bold pl-2 pr-4">
            <zt-icon name="times" />
          </button>
          <h2 class="text-lg font-semibold">{{ $t("message.virtualAssistantAI.title") }}</h2>
          <div class="inline-block m-2 flex justify-end">
            <div
              class="text-lg font-semibold text-red p-2 rounded-l border border-neutro-500 cursor-pointer hidden md:block"
              :class="{
                'bg-neutro': outputSelect == 'text',
                'text-white': outputSelect == 'text'
              }" @click="outputSelect = 'text', acceptTermsAndConditions(hasAcceptedAITermsAndConditions)"
              data-vs-button="isTextResponse">
              <zt-icon class="pb-1" name="text" />
              {{ $t("message.virtualAssistantAI.text") }}
              <!-- <zt-icon class="text-2xl" name="my-team-horizontal" /> -->
            </div>
            <div
              class="text-lg font-semibold text-red p-2 rounded-r border border-neutro-500 cursor-pointer hidden md:block"
              :class="{
                'bg-neutro': outputSelect == 'audio',
                'text-white': outputSelect == 'audio'
              }" @click="outputSelect = 'audio', acceptTermsAndConditions(hasAcceptedAITermsAndConditions)"
              data-vs-button="isTextResponse">
              <zt-icon class="text-2xl" name="microphone" />
              {{ $t("message.virtualAssistantAI.audio") }}
            </div>
          </div>
        </div>
        <hr class="mb-4 mt-2" />
        <div class="bg-neutro rounded m-2 mr-4 p-4 border-gray-400" v-if="!hasAcceptedAITermsAndConditions">
          <p class="pb-2">
            {{ $t("message.inicioComponent.botText", { user: this.$store.getters.getUser.nombre }) }}
          </p>
          <p>
            {{ $t("message.virtualAssistantAI.termsAndConditionsPrev") }}
          </p>
          <div class="w-8/12 flex rounded border border-gray-400 bg-white p-2 mt-2 cursor-pointer"
            @click="openTermsAndCondition()">
            <p class="pr-2">{{ $t("message.virtualAssistantAI.seeTermsAndCondition") }} </p>
            <zt-icon name="external-link" />
          </div>
          <zt-check-box v-model="confirmTermsAndCondition" value="1">
            {{ $t("message.virtualAssistantAI.termsAndConditionsAccept") }}
          </zt-check-box>
          <div class="mt-4">
            <zt-button class="w-full" :disabled="!confirmTermsAndCondition" @click="acceptTermsAndConditions()"> {{
              $t("message.virtualAssistantAI.start") }} </zt-button>
          </div>
        </div>
        <div v-if="hasAcceptedAITermsAndConditions">
          <div class="bg-neutro rounded m-2 mr-4 p-4 border-gray-400">
            <p class="py-3">
              {{ $t("message.virtualAssistantAI.selectQuestion") }}
            </p>
            <div>
              <div v-for="item in AIQuestions" @click="sendQuestion(item.id)" :key="item.id">
                <zt-chip square outline>
                  {{ item.pregunta }}
                </zt-chip>
              </div>
            </div>
          </div>
          <div class="" ref="chatContainer">
            <div class="bg-gray-400 rounded m-2 p-4 border-gray-400 bg-neutro"
              v-for="(message, index) in chatWithBackgroundColors" :key="index"
              :class="['chat-bubble', message.type, message.backgroundClass]">
              <template v-if="message.format === 'text'">
                {{ message.content }}
              </template>
              <template v-else-if="message.format === 'audio'">
                <audio controls>
                  <source :src="message.content" type="audio/mpeg">
                  {{ $t("message.virtualAssistantAI.audioNotSupported") }}
                </audio>
              </template>
              <template v-if="message.type === 'answer'">
                <div>
                  <p class="py-3"> {{ $t("message.virtualAssistantAI.consultAgain") }} <br>
                    {{ $t("message.virtualAssistantAI.moreInformation") }} </p>
                  <div v-for="item in AIQuestions" @click="sendQuestion(item.id)" :key="item.id">
                    <zt-chip square outline>
                      {{ item.pregunta }}
                    </zt-chip>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </zt-off-canvas>
  </div>
</template>

<script>
import AI from '@/apiClient/AI.js'
export default {
  props: {
    sendTermsAndConditions: Function,
    AIactive: {
      type: Boolean,
      default: false,
    },
    AIQuestions: {
      type: Array,
      required: true,
    },
    documentId: {
      type: String
    }
  },
  data() {
    return {
      confirmTermsAndCondition: null,
      askedQuestion: [],
      chatData: [
      ],
      currentInput: "",
      outputSelect: 'text',
      isSendingQuestion: false
    };
  },
  async created() {
    this.AI = new AI();
    await this.getOutputSelect()
  },
  computed: {
    chatWithBackgroundColors() {
      return this.chatData.map((message) => {
        const messageType = message.type;
        const backgroundClass = messageType === "answer" ? "answer" : "question";

        return {
          ...message,
          backgroundClass: backgroundClass,
        };
      });
    },
    hasAcceptedAITermsAndConditions() {
      const hasAcceptedAITermsAndConditions = this.$store.state.hasAcceptedAITermsAndConditions;
      return Object.keys(hasAcceptedAITermsAndConditions).length !== 0;
    }
  },
  methods: {
    async getOutputSelect() {
      const hasAcceptedAITermsAndConditions = this.$store.state.hasAcceptedAITermsAndConditions;
      this.outputSelect = Object.keys(hasAcceptedAITermsAndConditions).length !== 0
        ? hasAcceptedAITermsAndConditions.output
        : 'text';
    },

    acceptTermsAndConditions(update = false) {
      const confirm = update ? '1' : this.confirmTermsAndCondition;
      const output = this.outputSelect || 'text';
      const termsAndConfigData = { confirm, output };
      this.sendTermsAndConditions(termsAndConfigData);
    },
    getSoundIA(response) {
      const blob = new Blob([response], { type: 'audio/mpeg' })
      return window.URL.createObjectURL(blob)
    },


    async sendQuestion(id) {
      if (this.isSendingQuestion) {
        return;
      }
      try {
        this.isSendingQuestion = true;
        const askedQuestion = this.AIQuestions.find((el) => el.id == id);
        this.askedQuestion = askedQuestion.pregunta;
        this.pushMessageToChat(this.askedQuestion);
        let response = {}
        if (this.outputSelect === 'text') {
          response = await this.AI.getAnswer(this.documentId, askedQuestion.id);
          this.pushMessageToChat(response.data.data.respuesta, "answer");
        } else {
          response = await this.AI.getAnswer(this.documentId, askedQuestion.id, true);
          this.pushMessageToChat(this.getSoundIA(response.data), 'answer', 'audio');
        }

      }
      catch (error) {
        this.pushMessageToChat(this.$t('message.inicioComponent.failServer'), 'answer', 'text')
      }
      finally {
        this.isSendingQuestion = false;
        this.$nextTick(() => {
          const chatContainer = this.$refs.chatContainer;
          chatContainer.scrollTop = chatContainer.scrollHeight;
          const lastMessage = chatContainer.lastChild;
          if (lastMessage) {
            lastMessage.scrollIntoView({ behavior: 'smooth' });
          }
        });
      }
    },

    pushMessageToChat(content, messageType = "question", format = 'text') {
      const message = {
        type: messageType,
        content: content,
        format: format
      };
      this.chatData.push(message);
      this.currentInput = "";
    },
    openTermsAndCondition() {
      window.open('https://community.sichern.com/t5/tkb/workflowpage/tkb-id/ar_ra_sichern_Sabias_que/article-id/68', '_blank');
    }
  },
};
</script>

<style scoped>
.answer {
  margin-right: 10px;
  background-color: inherit;
}

.bg-neutro {
  background-color: #CCCCCC;
}

.question {
  background-color: #028FEF;
  margin-left: 30px;
  color: white
}

::v-deep.zt-chip {
  background-color: white !important;
  cursor: pointer;
}

::v-deep .zt-off-canvas {
  overflow-x: auto;
}
</style>
>
